/** @format */

export const courseUnitRealisationResponsibilityInfoTypeModelModule = 'sis-components.model.courseUnitRealisationResponsibilityInfoType';

(function () {
    initModuleResponsibilityInfoTypeModel.$inject = ['courseUnitRealisationResponsibilityInfoTypeModel', '$http', '$log'];
    courseUnitRealisationResponsibilityInfoTypeModel.$inject = ['DS'];
    angular
        .module(courseUnitRealisationResponsibilityInfoTypeModelModule, ['js-data'])
        .factory('courseUnitRealisationResponsibilityInfoTypeModel', courseUnitRealisationResponsibilityInfoTypeModel)
        .run(initModuleResponsibilityInfoTypeModel);

    function courseUnitRealisationResponsibilityInfoTypeModel(DS) {
        return DS.defineResource({
            idAttribute: 'urn',
            name: 'courseUnitRealisationResponsibilityInfoType',
            endpoint: '/kori/api/cached/codebooks/urn:code:course-unit-realisation-responsibility-info-type',
            watchChanges: false,
        });
    }

    function initModuleResponsibilityInfoTypeModel(courseUnitRealisationResponsibilityInfoTypeModel, $http, $log) {
        $http
            .get(courseUnitRealisationResponsibilityInfoTypeModel.endpoint)
            .then(function (response) {
                courseUnitRealisationResponsibilityInfoTypeModel.inject(_.values(response.data));
            })
            .catch(function (error) {
                $log.error(error);
            });
    }
})();
